// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 
console.log('%c This site was designed & developed by https://www.sleeplessmedia.com', 'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'); // Create our number formatter.

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD' // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

}); // Cookies functions

function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}
jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault(); // If item clicked on is open, close it

    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  // Show / hide address add form
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  }); // Show / hide address add form

  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  /******************************************
   QTY Selector ( Simple quantity box increase / decrease )
  ******************************************/
  // PDP / PLP
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
  });
  $('body').on('click', '.product--default .btn--atc', function () {
    var id = $(this).attr('data-id');
    CartJS.addItem(parseInt(id), 1, {}, {
      "success": function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + errorThrown + '!');
      }
    });
  }); // MAIN CART
  // Allow typing of input qty for update

  var timer;
  $('.col__qty, .mobile-stuff').on('keyup', '.qty input', function () {
    var $this = $(this);
    var newVal = $this.val();
    var lineNum = $this.closest('.cart-row').attr('data-linenum'); // clear the previous timer

    clearTimeout(timer); // create a new timer with a delay of 300ms seconds,
    // if the keyup is fired before the 300ms secs then the timer will be cleared

    timer = setTimeout(function () {
      // this will be executed if there is a gap of 300ms seconds between 2 keyup events
      CartJS.updateItem(lineNum, newVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }, 300);
  });
  $('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }

    if (qtyInputVal >= 1) {
      console.log('got here');
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }
  }); // MAIN CART REMOVE

  $('.cart__whiteBox .remove-product').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineID = $this.closest('.cart-row').attr('data-lineid');
    CartJS.removeItemById(lineID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  });
  /******************************************
    Options to change SM-RC Widget dropdowns
   ******************************************/
  // SELECT TYPE

  $('.option__wrap select').on('change', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  }); // BUTTON TYPE

  $('.option__wrap button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option'); // Set visual display of active

    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  }); // RECHARE WIDGET VARIANTS

  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  }); // RECHARE WIDGET SUBSCRIPTION PLAN

  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blogContent__filter').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  /******************************************
     Header Search
   ******************************************/
  // Show desktop search on click and focus on input
  $('.icon--search').on('click', function (e) {
    e.preventDefault();
    $('.desktop-search').fadeIn('fast', '', function () {
      $('body').addClass('search-open');
      $('.desktop-search input').focus();
    });
  }); // Close desktop search if click outside

  $('body').on('click', function (e) {
    var desktopSearch = $('.desktop-search');

    if (!desktopSearch.is(e.target) && desktopSearch.has(e.target).length === 0 && $('body').hasClass('search-open')) {
      desktopSearch.fadeOut('fast', '', function () {
        $('body').removeClass('search-open');
        $('.icon--search').focus();
      });
    }
  });
  /******************************************
    Mobile Menu
  ******************************************/
  // Trigger mobile menu display

  $('.header__mobile-trigger button').on('click', function () {
    $(this).toggleClass('is-active');
    $('.mobile-menu').fadeToggle('fast', '', function () {
      $('html').toggleClass('mobile-menu-open');
    });
  });
  /******************************************
    Modals
  ******************************************/
  // Launch the modal

  $('.btn--modal').on('click', function (e) {
    e.preventDefault();
    var modalID = '#' + $(this).attr('data-modal');

    if ($(this)[0].hasAttribute('data-video-yt')) {
      var videoID = $(this).attr('data-video-yt');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    }

    if ($(this)[0].hasAttribute('data-video-vimeo')) {
      var videoID = $(this).attr('data-video-vimeo');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' + videoID + '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>');
    }

    $(modalID).fadeIn('fast');
  }); // Close the modal

  $('.modal--close, .modal__bg').on('click', function (e) {
    closeModal($(this));
  });
});

function closeModal(object) {
  object.closest('.modal').fadeOut('fast', function () {
    $('.modal__inner .iframe-wrap').remove();
  });
}
jQuery(document).ready(function ($) {
  function isEmpty(el) {
    return !$.trim(el.html());
  }

  if (isEmpty($('.colMain__paginationWrapper'))) {
    $('.colMain__paginationWrapper').hide();
  }

  $('.colMain__filter').on('change', function () {
    window.location = $(this).val();
  });
  $('.colMain__mobileFilterButton').on('click', function () {
    $('.colMain__filterBar').slideToggle();
  });
});
jQuery(document).ready(function ($) {
  $('.pageContent__inner').find('iframe').each(function () {
    $(this).parent().addClass('iframeWrapper');
  });
  $('.accordionBox__question').on('click', function () {
    var _container = $(this).closest('.accordionBox');

    var _section = $(this).closest('[data-builder-index]');

    if (_container.hasClass('accordionBox--active')) {
      _section.removeClass('accordionBox--active');

      _container.find('.accordionBox__body').slideUp();
    } else {
      _section.find('.accordionBox').removeClass('accordionBox--active');

      _section.find('.accordionBox__body').slideUp();

      _container.addClass('accordionBox--active');

      _container.find('.accordionBox__body').slideDown();
    }
  });
  $('.mobAnchors__select').on('change', function () {
    var tagUrl = $(this).val();
    $('html, body').animate({
      scrollTop: $(tagUrl).offset().top
    }, 500);
  });
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
});
jQuery(document).ready(function ($) {
  // Update offset on scroll
  var lastScrollTop = $(window).scrollTop();
  $(window).on('scroll resize', function () {
    if ($(window).scrollTop() > 40) {
      closeAlertBar(false);
      $('body').addClass('body--scrolled');
    } else {
      openAlertBar();
      $('body').removeClass('body--scrolled');
    }

    if ($(window).scrollTop() > lastScrollTop) {
      $('body').removeClass('body--scrolledUp');
    } else {
      if ($(window).scrollTop() > 40) {
        $('body').addClass('body--scrolledUp');
      } else {
        $('body').removeClass('body--scrolledUp');
      }
    }

    lastScrollTop = $(window).scrollTop();
  }); //bind close button to close bar

  $('.adBar__close').on('click', function () {
    closeAlertBar(true);
  }); //if argument is true ad class to mark the bar closed by user

  function closeAlertBar(addClass) {
    
  } //if bar was not closed by user open bar back up


  function openAlertBar() {
    
  }

  function initHeaderAnimation() {
    var outlineTarget = $('.deskHeader__logo--outline');
    var filledTarget = $('.deskHeader__logo--filled');

    if (window.innerWidth <= 900) {
      outlineTarget = $('.mobHeader__logo--outline');
      filledTarget = $('.mobHeader__logo--filled');
    }

    var firstFlickerOn = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:1;');
    }, 500);
    var firstFlickerOff = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:0;');
    }, 600);
    var secondFlickerOn = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:1;');
    }, 1000);
    var secondFlickerOff = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:0;');
    }, 1100);
    var thirdFlickerOn = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:1;');
    }, 1300);
    var thirdFlickerOff = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:0;');
    }, 1400);
    var FourthFlickerOn = setTimeout(function () {
      outlineTarget.attr('style', 'opacity:1;');
    }, 2000);
    var whiteFadein = setTimeout(function () {
      filledTarget.fadeIn(1000);
      outlineTarget.fadeOut(1000);
    }, 2000);
  }

  initHeaderAnimation();
  var mobNavOpen = false;
  $('.mobHeader__burgerButton').on('click', function () {
    var heightOffset = 70;

    if ($('.body--scrolled').length == 0) {
      heightOffset += 37;
    }

    $('.mobNav__decorationWrapper').css('height', 'calc(100vh - ' + heightOffset + 'px - 100%)');
    $('.mobNav').css('height', 'calc(100vh - ' + heightOffset + 'px)');

    if (mobNavOpen == true) {
      $('.mobNav').fadeOut();
      $('.mobHeader__burger').attr('src', 'https://cdn.shopify.com/s/files/1/0105/5444/1779/files/burger.png?v=1719249641');
      $('html').removeClass('no-scroll');
      mobNavOpen = false;
    } else {
      $('.mobNav').fadeIn();
      $('.mobHeader__burger').attr('src', 'https://cdn.shopify.com/s/files/1/0105/5444/1779/files/burger_19623872-35d2-4b96-9bb0-f48fbadc4a0d.png?v=1719251198');
      $('html').addClass('no-scroll');
      mobNavOpen = true;
    }
  });
  $('.mobNav__accordionButton').on('click', function () {
    var accordion = $(this).parent();

    if (accordion.find('.mobNav__accordionDrawer').is(':visible')) {
      accordion.removeClass('mobNav__accordion--open');
      accordion.find('.mobNav__accordionDrawer').slideUp();
    } else {
      $('.mobNav__accordion--open').find('.mobNav__accordionDrawer').slideUp();
      $('.mobNav__accordion--open').removeClass('mobNav__accordion--open');
      accordion.addClass('mobNav__accordion--open');
      accordion.find('.mobNav__accordionDrawer').slideDown();
    }
  });
  $('.mobFooter__accordionButton').on('click', function () {
    var accordion = $(this).parent();

    if (accordion.find('.mobFooter__accordionDrawer').is(':visible')) {
      accordion.removeClass('mobFooter__accordion--open');
      accordion.find('.mobFooter__accordionDrawer').slideUp();
    } else {
      $('.mobFooter__accordion--open').find('.mobFooter__accordionDrawer').slideUp();
      $('.mobFooter__accordion--open').removeClass('mobFooter__accordion--open');
      accordion.addClass('mobFooter__accordion--open');
      accordion.find('.mobFooter__accordionDrawer').slideDown();
    }
  });
});
jQuery(document).ready(function ($) {
  var timerOne;
  var timerTwo;
  var positionOne = 'transform: translateX(calc(-100% / 3));';
  var positionTwo = 'transform: translateX(calc((-100% / 3) * 2));';
  var animatingClass = 'homeMerch__marqueeSled--animating';

  function resetMarquee(marqueeElement) {
    var target = marqueeElement.find('.homeMerch__marqueeSled');
    target.removeClass(animatingClass);

    if (marqueeElement.attr('marquee-scroll') == 'right') {
      target.attr('style', positionOne);
      setTimeout(function () {
        target.addClass(animatingClass);
        target.attr('style', positionTwo);
      }, 10);
    } else {
      target.attr('style', positionTwo);
      setTimeout(function () {
        target.addClass(animatingClass);
        target.attr('style', positionOne);
      }, 10);
    }
  }

  $('[marquee-scroll]').each(function () {
    var targetHtml = $(this).find('.homeMerch__marqueeSled').html();
    $(this).find('.homeMerch__marqueeSled').append(targetHtml);
    $(this).find('.homeMerch__marqueeSled').append(targetHtml);
    $(this).find('.homeMerch__marqueeContent').first().addClass('homeMerch__marqueeContent--pre');
    $(this).find('.homeMerch__marqueeContent').last().addClass('homeMerch__marqueeContent--post');
  });
  setInterval(function () {
    console.log('resetMarquee Interval');
    $('[marquee-scroll]').each(function () {
      resetMarquee($(this));
    });
  }, 10000);
  $('[marquee-scroll]').each(function () {
    resetMarquee($(this));
  });
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $('.mini-cart__bg, .mini-cart__content .close').on('click', function () {
    closeMini();
  }); // Show mini cart

  $('.deskHeader__cartButton, .mobHeader__cartButton').on('click', function (e) {
    e.preventDefault();

    if (!$('body').hasClass('template__cart')) {
      showMini();
    } else {
      e.preventDefault();
    }
  }); // Mini Cart Remove Product

  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').attr('data-lineid');
    $(this).closest('.product').addClass('removed');
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Mini Cart Upsell ATC

  $('.mini-cart__upsell .action--atc').on('click', function (e) {
    e.preventDefault();
    var dataId = $(this).closest('.upsell').attr('data-id');
    CartJS.addItem(dataId, 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Mini Cart Qty

  $('.mini-cart__list').on('click', '.js-qty--mini', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }

    CartJS.updateItem(lineNum + 1, qtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Allow typing of input qty for update

  var timer;
  $('.mini-cart__list').on('keyup', '.actions .qty-val', function () {
    var $this = $(this);
    var newVal = $this.val();
    var lineData = $this.closest('.product').data('lineid'); // clear the previous timer

    clearTimeout(timer); // create a new timer with a delay of 300ms seconds,
    // if the keyup is fired before the 300ms secs then the timer will be cleared

    timer = setTimeout(function () {
      // this will be executed if there is a gap of 300ms seconds between 2 keyup events
      console.log(newVal);
      CartJS.updateItem(lineData, newVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON('/cart.js', function (cart) {
            refreshMiniCart(cart);
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }, 300);
  });
});

function closeMini() {
  $('body, html').removeClass('cart-open');
  $('.mini-cart').removeClass('is-open');
  $('.mini-cart').fadeOut('fast');
}

function showMini() {
  $('body, html').addClass('cart-open');
  $('.mini-cart').fadeIn('fast');
  $('.mini-cart').addClass('is-open'); // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = ''; // Free shipping updater

  var totalShip = parseInt($('.mini-cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;

  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__ship').addClass('is-free');
  } else {
    if ($('.mini-cart__ship').hasClass('is-free')) {
      $('.mini-cart__ship').removeClass('is-free');
    }

    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  } // If cart is now empty


  if (cartData.item_count == 0) {
    newCartHtml += ' <h3 class="text-center">Cart is empty</h3>';
  } else {
    // Build html of new products in cart
    $.each(cartItems, function (index, item) {
      // Opening
      console.log(item);
      newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
      newCartHtml += ' <div class="product__image">';

      if (item.featured_image) {
        newCartHtml += '<a href="' + item.url + '">';
        newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.image.alt + '">';
        newCartHtml += '</a>';
      }

      newCartHtml += '</div>';
      newCartHtml += '<div class="product__info">';
      newCartHtml += '<div class="title d-flex">';
      newCartHtml += '<h3 class="heading--four d-flex justify-between">';
      newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
      newCartHtml += item.product_title;
      newCartHtml += '</a>';
      newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
      newCartHtml += '</h3>';

      if (item.options_with_values != null && item.options_with_values[0].name != 'Title') {
        $.each(item.options_with_values, function (index, value) {
          console.log('index:' + index);
          console.log('value:' + value);
          newCartHtml += '<div class="var">';
          newCartHtml += '<span>' + item.options_with_values[index].name + ': ' + item.options_with_values[index].value + '</span>';
          newCartHtml += '</div>';
        });
      }

      if (item.hasOwnProperty('selling_plan_allocation')) {
        newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
      }

      newCartHtml += '<span class="unit-price">' + formatter.format(item.price / 100) + '</span>';
      newCartHtml += '</div>'; // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';

      newCartHtml += "<div class=\"actions d-flex align-center justify-between\">\n\t\t\t\t\t\t<div class=\"action action--qty\">\n\t\t\t\t\t\t\t<div class=\"qty d-flex align-center\">\n\t\t\t\t\t\t\t\t<button class=\"js-qty js-qty--mini js-qty--minus trans\">\n\t\t\t\t\t\t\t\t\t<span class=\"sr-only\">Decrease</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<input type=\"text\" value=\"" + item.quantity + "\" min=\"1\"  type=\"number\" class=\"qty-val\" />\n\t\t\t\t\t\t\t\t<button class=\"js-qty js-qty--mini js-qty--plus trans\">\n\t\t\t\t\t\t\t\t\t<span class=\"sr-only\">Increase</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>";
      newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>';
      newCartHtml += '</div>'; // Closing

      newCartHtml += '</div>';
      newCartHtml += '</div>';
    });
  } // Clear current products in cart


  $('.mini-cart__items').empty(); // Set new subtotal

  $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100)); // Set new header icon count

  $('.icon--cart .cart-count span ').text(cartData.item_count); // Add updated producst to mini cart

  $('.mini-cart__list').html(newCartHtml); // Show mini cart

  showMini();
}
jQuery(document).ready(function ($) {
  var productThumbSwiperData = {
    slidesPerView: 5,
    spaceBetween: 12,
    loop: false,
    slideToClickedSlide: true
  };
  var productThumbSwiper = new Swiper('.product__thumbs', productThumbSwiperData);
  var productGallerySwiperData = {
    slidesPerView: 1,
    loop: true,
    thumbs: {
      swiper: productThumbSwiper
    }
  };
  var productGallerySwiper = new Swiper('.product__gallery', productGallerySwiperData);
  var prodRecommendSliderData = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.prodUpsell__sliderNext',
      prevEl: '.prodUpsell__sliderPrevious'
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 10
      }
    }
  };
  var prodRecommendSlider = new Swiper('.prodUpsell__swiperWrapper', prodRecommendSliderData);
  $('.product__accordionTop').on('click', function () {
    var accordion = $(this).parent();
    var container = accordion.find('.product__accordionFrame');

    if (container.is(':visible')) {
      container.slideUp();
      accordion.removeClass('product__accordionContainer--active');
    } else {
      $('.product__accordionFrame').slideUp();
      $('.product__accordionContainer').removeClass('product__accordionContainer--active');
      container.slideDown();
      accordion.addClass('product__accordionContainer--active');
    }
  });
  $('.product__accordionTop').first().click();
  $('.product__shareButton').on('click', function () {
    var urlTarget = $('.product__shareUrl');
    urlTarget.select();
    document.execCommand('copy');
    $('.product__shareTitle').text('URL Copied!');
  });
  $('.product__optionButton').on('click', function () {
    var container = $(this).closest('.product__optionWrapper');
    var targetText = '[sm-rc-option3-selector]';

    if (container.hasClass('product__optionWrapper--1')) {
      targetText = '[sm-rc-option1-selector]';
    } else if (container.hasClass('product__optionWrapper--2')) {
      targetText = '[sm-rc-option2-selector]';
    }

    var optionValue = $(this).attr('data-name');
    $(targetText).val(optionValue).change();
    container.find('.product__optionButton').removeClass('product__optionButton--active');
    $(this).addClass('product__optionButton--active');
  });
  $('.product__quantityMinus').on('click', function () {
    console.log('subtract quantity');
    var qty = $('.product__quantityDisplay').attr('data-quantity') * 1;

    if (qty > 1) {
      qty -= 1;
    }

    $('.sm-rc-widget [sm-rc-quantity-selector]').val(qty).change(); //$('.product__quantityDisplay').attr('data-quantity', qty);
    //$('.product__quantityDisplay').text(qty);
  });
  $('.product__quantityPlus').on('click', function () {
    console.log('add quantity');
    var qty = $('.product__quantityDisplay').attr('data-quantity') * 1;
    qty += 1;
    $('.sm-rc-widget [sm-rc-quantity-selector]').val(qty).change(); //$('.product__quantityDisplay').attr('data-quantity', qty);
    //$('.product__quantityDisplay').text(qty);
  });
  $('.sm-rc-widget [sm-rc-quantity-selector]').on('change', function () {
    var newVal = $(this).val();
    $('.product__quantityDisplay').attr('data-quantity', newVal).text(newVal);
  });
});
jQuery(document).ready(function ($) {
  var sliderArray = [];
  var swiperCount = 0;
  $('[data-builder-index] .swiper-wrapper').each(function () {
    var thisIndex = $(this).closest('[data-builder-index]').attr('data-builder-index');
    var thisParent = $(this).parent();

    if (thisParent.hasClass('homeMenu__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        spaceBetween: 20,
        freeMode: {
          enabled: true,
          sticky: true
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        loop: false,
        initialSlide: 1,
        breakpoints: {
          1000: {
            slidesPerView: 2,
            spaceBetween: 80
          }
        }
      };
      sliderArray[swiperCount] = new Swiper('[data-builder-index="' + thisIndex + '"] .homeMenu__sliderWrapper', swiperData);
      swiperCount++;
    } else if (thisParent.hasClass('homeCrew__sliderContainer')) {
      var swiperData = {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 5000
        },
        navigation: {
          nextEl: '.homeCrew__sliderNext',
          prevEl: '.homeCrew__sliderPrevious'
        }
      };
      sliderArray[swiperCount] = new Swiper('[data-builder-index="' + thisIndex + '"] .homeCrew__sliderContainer', swiperData);
      swiperCount++;
    } else if (thisParent.hasClass('homePress__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        allowTouchMove: false,
        speed: 5000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        freeMode: {
          enabled: true,
          sticky: true
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        breakpoints: {
          1000: {
            slidesPerView: 4,
            spaceBetween: 60
          }
        }
      };
      sliderArray[swiperCount] = new Swiper('[data-builder-index="' + thisIndex + '"] .homePress__sliderWrapper', swiperData);
      swiperCount++;
      
    } else if (thisParent.hasClass('pageLocation__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 5000
        },
        freeMode: {
          enabled: true,
          sticky: true
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true
        }
      };
      sliderArray[swiperCount] = new Swiper('[data-builder-index="' + thisIndex + '"] .pageLocation__sliderWrapper', swiperData);
      swiperCount++;
    } else if (thisParent.hasClass('mediaScroll__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 3,
        spaceBetween: 40,
        freeMode: true,
        loop: true,
        allowTouchMove: false,
        speed: 6000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        breakpoints: {
          1000: {
            slidesPerView: 6,
            spaceBetween: 60
          }
        }
      };
      sliderArray[swiperCount] = new Swiper('[data-builder-index="' + thisIndex + '"] .mediaScroll__sliderWrapper', swiperData);
      swiperCount++;
    }
  });
});